import EmailValidator from "email-validator"
import { validateVat, validateAddress } from "../internal-api/commerce/address"
import { dialCodes } from "../constants/countries"
import { AddressType } from "../components/commerce/address-form/fields"
import React from "react"

export interface AddressValidation {
  type: AddressType
  street: string
  home_no: string
  apartment: string
  city: string
  state: string
  country_code: string
  zip_code: string
}

export const emptyValueValidator = (value: string) => Boolean(value)
export const numbersOnly = (value: string) =>
  /^\+[\d\s]+$/.test(value) /* numbers with spaces and + */

export const startsWithDialCode = (value: string) => {
  return dialCodes.find((item) => value.startsWith(item.value))
}

export const isPhoneNumberValid = (value: string) => {
  const code = startsWithDialCode(value)
  // 5 is a minimum length of a phone number for the whole world
  const properLength = code
    ? value.replace(" ", "").length >= code.value.length + 5
    : false
  return properLength && numbersOnly(value)
}

export const vatValidator =
  (countryCode: string) => async (vatNumber: string) => {
    if (!vatNumber || !countryCode) {
      return false
    }
    try {
      const { vatMember } = await validateVat(vatNumber, countryCode)
      return vatMember
    } catch (error) {
      return false
    }
  }

export const defaultRequired = {
  required: { value: true, message: "This field is required." },
}
export const isEmail = (email: string) => EmailValidator.validate(email)

export const addressValidator = async (data: AddressValidation[]) => {
  const { result } = await validateAddress({ data })
  return result
}

export const maxCharRequired = (maxChar: number) => {
  return {
    required: { value: true, message: "This field is required." },
    maxLength: {
      value: maxChar,
      message: "You have exceeded the maximum character limit.",
    },
  }
}

export const validateCustomInput = (
  label: string,
  value: string | boolean,
  required: boolean,
  setValidationErrors: React.Dispatch<
    React.SetStateAction<{
      [key: string]: string
    }>
  >
): void => {
  // Validation
  if (required && value === "") {
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [label]: "This field is required.",
    }))
  } else if (
    label === "E-Mail address" &&
    required &&
    !isEmail(value as string)
  ) {
    void setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [label]: "Invalid email address.",
    }))
  } else if (
    label === "Contact phone number" &&
    !isPhoneNumberValid(value as string) &&
    String(value).length > 0
  ) {
    void setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [label]: "Invalid phone number. Type valid phone number with prefix.",
    }))
  } else {
    void setValidationErrors((prevErrors) => {
      const prevState = {
        ...prevErrors,
        [label]: "",
      }
      return prevState
    })
  }
}
